import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const useStyles = buildUseStyles('LeverFieldGroupLayout', (theme) => ({
  lever: {
    display: 'flex',
    flex: 1,
    '& > div': {
      justifyContent: 'space-between',
      flex: 1,
    },
    '& .FD-MuiFormControl-root': {
      // TODO: investigate this, seems like min-width of 200 is causing alignment issues for picklist inputs
      width: '204px', // fixes alignment of widths between inputs and picklist inputs
    },
    '&& div.FD-MuiInputBase-root': { // the border of the input field
      height: theme.spacing(4), // make inputs thinner
    },
    '&& input.FD-MuiInputBase-input.FD-MuiAutocomplete-input': {
      marginTop: theme.spacing(-1), // Fix picklist text alignment
    },
    '&&& input': {
      color: theme.palette.facet.oceana500, // change color of input text
      fontWeight: 500, // bold
    },
  },
}));

/**
 * Group lever layout that renders a column of MetaControlField(s)
 * based on the provided meta field names.
 */
const LeverGroupLayout = ({ disabled, onBlur, fields }) => {
  const classes = useStyles();
  const { resource } = useMetaLayoutContext();

  const onBlurIfValid = useCallback(async () => {
    if (!resource.isValid()) return null;
    return onBlur();
  }, [resource, onBlur]);

  // Submit on Enter key if valid (workaround for onInlineSubmit)
  const handleKeyCapture = React.useCallback((e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      onBlurIfValid();
    }
  }, [onBlurIfValid]);

  return (
    <div className={classes.lever} onKeyDownCapture={handleKeyCapture}>
      <FDStack direction="column" spacing={1}>
        {fields.map((attr) => (
          <MetaControlField
            key={attr}
            attr={attr}
            onBlur={onBlurIfValid}
            disabled={disabled}
          />
        ))}
        <MetaControlField attr={'originalValue'} />
      </FDStack>
    </div>
  );
};

LeverGroupLayout.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onBlur: PropTypes.func.isRequired,
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default LeverGroupLayout;
